class Scroll {
  constructor(options) {
    // Default options
    const defaultOptions = {
      offset: 50, // Space on top in pixels
      duration: 800, // Duration of the scroll in milliseconds
      easing: "easeInOutCubic", // Easing function
    };
    // Merge user options with default options
    this.options = Object.assign({}, defaultOptions, options);

    // Easing functions
    this.easingFunctions = {
      linear: function (t) {
        return t;
      },
      easeInQuad: function (t) {
        return t * t;
      },
      easeOutQuad: function (t) {
        return t * (2 - t);
      },
      easeInOutQuad: function (t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      },
      easeInCubic: function (t) {
        return t * t * t;
      },
      easeOutCubic: function (t) {
        return --t * t * t + 1;
      },
      easeInOutCubic: function (t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      },
      easeInQuart: function (t) {
        return t * t * t * t;
      },
      easeOutQuart: function (t) {
        return 1 - --t * t * t * t;
      },
      easeInOutQuart: function (t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
      },
      easeInQuint: function (t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function (t) {
        return 1 + --t * t * t * t * t;
      },
      easeInOutQuint: function (t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
      },
      // Add more easing functions as needed
    };

    // Bind the click event on anchor links
    this.bindClickEvents();
  }

  bindClickEvents() {
    // Select all anchor links with href starting with '#'
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link) => {
      link.addEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      this.scrollToElement(targetElement);
    }
  }

  scrollToElement(element) {
    // Calculate the target position considering the offset
    const rect = element.getBoundingClientRect();
    const targetPosition = rect.top + window.pageYOffset - this.options.offset;

    // Start the animation
    this.animateScrollTo(
      targetPosition,
      this.options.duration,
      this.options.easing
    );
  }

  animateScrollTo(targetPosition, duration, easing) {
    const start = window.pageYOffset;
    const change = targetPosition - start;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = elapsedTime / duration;
      const t = Math.min(progress, 1);

      const easingFunction =
        this.easingFunctions[easing] || this.easingFunctions["linear"];
      const position = start + change * easingFunction(t);

      window.scrollTo(0, position);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }
}

export default Scroll;

